/**
 * Адреса файлов конвейера: том генерации и read-only корень хранилища макетов.
 *
 * Оба маршрута закрыты правом Pipeline:READ, поэтому картинки по ним едут через
 * авторизованный транспорт (shared/media/authorizedMedia) — прямой `<img src>`
 * заголовок Authorization не передаёт и получил бы 401.
 *
 * Строители живут здесь, а не в карточке макета: тот же адрес нужен каталогу
 * товаров, и копия успела бы разойтись с оригиналом — в этом проекте так уже
 * бывало трижды.
 */

/** Корень тома хранилища в путях `product_artifacts.storage_path`. */
const MAKETS_STORE_ROOT = '/data/makets'

export const productionFileUrl = (path: string, preview = false): string =>
  `/api/v1/pipeline/production-file?path=${encodeURIComponent(path)}${preview ? '&preview=1' : ''}`

export const maketsFileUrl = (path: string): string =>
  `/api/v1/pipeline/makets-file?path=${encodeURIComponent(path)}`

/**
 * Кадр воронки из тома генерации по относительному пути
 * (`pt3_base/ksa/pt3_01_main/126447.jpg`).
 *
 * Тот же файл доступен и публичным адресом FTP, но там только полный кадр:
 * этот маршрут понимает `w` и отдаёт webp-миниатюру.
 */
export const generatedVisualUrl = (path: string): string =>
  `/api/v1/pipeline/visual?path=${encodeURIComponent(path)}`

/**
 * Путь артефакта → путь относительно корня хранилища: маршрут принимает
 * `PDF/126908.pdf`, а в базе лежит `/data/makets/PDF/126908.pdf`.
 */
export function maketsRelativePath(storagePath?: string | null): string | null {
  const value = String(storagePath || '').trim().replace(/\\/g, '/')
  if (!value) return null
  if (value.startsWith(`${MAKETS_STORE_ROOT}/`)) return value.slice(MAKETS_STORE_ROOT.length + 1)
  return value.startsWith('/') ? null : value
}

/**
 * Ширина превью по умолчанию. Без неё маршрут отдаёт оригинал — для PDF это не
 * картинка вовсе, а для крупного PNG лишние мегабайты в списке. Потребитель,
 * которому нужна другая ширина, перезапишет параметр (thumbnailMediaUrl).
 */
export const MAKETS_PREVIEW_WIDTH = 480

/** Адрес превью файла печати по его месту в хранилище. */
export function maketsPreviewUrl(
  storagePath?: string | null,
  width: number = MAKETS_PREVIEW_WIDTH,
): string | null {
  const relative = maketsRelativePath(storagePath)
  return relative ? `${maketsFileUrl(relative)}&w=${Math.round(width)}` : null
}
